import { render, staticRenderFns } from "./RichTextWidget.vue?vue&type=template&id=2d4bda8a&scoped=true"
import script from "./RichTextWidget.vue?vue&type=script&lang=js"
export * from "./RichTextWidget.vue?vue&type=script&lang=js"
import style0 from "./RichTextWidget.vue?vue&type=style&index=0&id=2d4bda8a&lang=scss&scoped=true"
import style1 from "./RichTextWidget.vue?vue&type=style&index=1&id=2d4bda8a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4bda8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4bda8a')) {
      api.createRecord('2d4bda8a', component.options)
    } else {
      api.reload('2d4bda8a', component.options)
    }
    module.hot.accept("./RichTextWidget.vue?vue&type=template&id=2d4bda8a&scoped=true", function () {
      api.rerender('2d4bda8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/RichTextWidget.vue"
export default component.exports